import { render, staticRenderFns } from "./AmplificationChart.vue?vue&type=template&id=0913caca&"
import script from "./AmplificationChart.vue?vue&type=script&lang=js&"
export * from "./AmplificationChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports